import { Maybe } from "../../../../graphql/generated-types"

export const getOnlineOrderingTitle = (accountName: Maybe<string>, locationName: Maybe<string>, suffix?: string) => {
    return [accountName, locationName].filter((l) => !!l).join(" - ") + (suffix || "")
}
